import { Dispatch } from "redux"

export type ActionType = {
  type?: string
  data?: Array<object>
}

export type StateType = {
  symbols?: Array<object>
  month?: number
}

/************************************
 * ACTION TYPE
 ************************************/
export const REDUX_SET_CALENDER_DATA = "REDUX_SET_CALENDER_DATA"
export const REDUX_SET_MONTH_DATA = "REDUX_SET_MONTH_DATA"
export const REDUX_INITIAL_CALENDER_DATA = "REDUX_INITIAL_CALENDER_DATA"

/************************************
 * ACTIONS
 ************************************/
export const setSymbols: (data: Array<object>) => any = data => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: REDUX_SET_CALENDER_DATA,
      data: data,
    })
  }
}

export const setMonth: (month: number) => any = data => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: REDUX_SET_MONTH_DATA,
      data: data,
    })
  }
}

export const initialSymbol = () => {
  return {
    type: REDUX_INITIAL_CALENDER_DATA,
  }
}

/************************************
 * REDUCER
 ************************************/
const initialState: StateType = {
  symbols: [],
  month: 1,
}

export default (state: any = initialState, action: ActionType) => {
  switch (action.type) {
    case REDUX_SET_CALENDER_DATA:
      return {
        ...state,
        symbols: action.data,
      }
    case REDUX_SET_MONTH_DATA:
      return {
        ...state,
        month: action.data,
      }
    case REDUX_INITIAL_CALENDER_DATA:
      return {
        initialState,
      }
    default:
      return state
  }
}
